export default {"src":"/_next/static/media/FTI.c957068b.svg","height":18,"width":18};